module.exports = __webpack_public_path__ + "static/media/biblio_nash.40860a76.pdf";